import { GetListRes } from "./GetListRes";

export enum TableColumnKey {
  Operation = "operation",
  BatchId = "batchId",
  MerchantName = "merchantName",
  ChainName = "chainName",
  Currency = "currency",
  AssetName = "assetName",
  SpenderAddress = "spenderAddress",
  InvokerAddress = "invokerAddress",
  SpenderContractVersion = "spenderContractVersion",
  SpenderContractId = "spenderContractId",
  TotalCount = "totalCount",
  ClientData = "clientData",
  CreationTime = "creationTime",
  LastModifiedTime = "lastModifiedTime",
  ViewOperation = "viewOperation",
  ViewOperationTransaction = "viewOperationTransaction",
  ViewTronRentResourceRecords = "viewTronRentResourceRecords",
  Status = "status",
  SmartAccountType = "smartAccountType",
}

export type TableRow = { [K in TableColumnKey]?: string } & {
  id: number;
  rawData?: GetListRes;
};
